import { format } from "date-fns";
import { useContext } from "react";
import { useQueries } from "react-query";
import { getTransactions } from "../api-services/finance-views";
import { FINANCE_HISTORY_DAY_FORMAT } from "../commons/enum";
import JointAccountContext from "../context/joint-account-context";
import { useSelectedJointAccountDebtTransaction } from "./joint-account.hooks";
import { useQueryInvalidationWithNotification } from "./util.hooks";

export const useInvalidateTransactions = () => {
  const invalidateQueries = useQueryInvalidationWithNotification();
  return () => {
    invalidateQueries("financeHistory");
    invalidateQueries("expenses");
    invalidateQueries("accountTransactions");
    invalidateQueries("jointAccountTransactions");
    invalidateQueries("incomesExpensesSummaryByMonth");
  };
};

export const useIndividualTransactions = ({
  accountIds = [],
  direction,
  limit,
  txClass,
  from,
  to,
}) => {
  const { selectedJointAccount = "" } = useContext(JointAccountContext);
  return useQueries(
    accountIds.map((accountId) => ({
      queryKey: [
        "transactions",
        { accountId, direction, limit, txClass, from, to },
      ],
      queryFn: () =>
        getTransactions({ accountId, direction, limit, txClass, from, to }),
      select: (response) => ({
        accountId: accountId.toString(),
        transactions: response.data,
      }),
      enabled: !selectedJointAccount,
    }))
  );
};
export const useTransactions = (debtTransactionParams) => {
  const { selectedJointAccount = "" } = useContext(JointAccountContext);
  const formattedDebtTransactionParams = {
    ...debtTransactionParams,
    from: format(debtTransactionParams.from, FINANCE_HISTORY_DAY_FORMAT),
    to: format(debtTransactionParams.to, FINANCE_HISTORY_DAY_FORMAT),
  };
  const jointAccountDebtTransaction = useSelectedJointAccountDebtTransaction(
    formattedDebtTransactionParams
  );
  const balanceHistories = useIndividualTransactions(
    formattedDebtTransactionParams
  );
  if (selectedJointAccount) {
    return jointAccountDebtTransaction;
  }
  return balanceHistories;
};
